// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "addNewMemberForm-2PO6c";
export { _1 as "__esModule", _2 as "addNewMemberForm" }
export default { "__esModule": _1, "addNewMemberForm": _2 }
